import React from 'react';
import { MenuItem, Select, SelectChangeEvent, SxProps, Typography } from '@mui/material';
import { labelFontSemiBold, headingFontBold, vars } from '../../../../Theme';

import { useTranslation } from 'react-i18next';
import ChipWithTooltip from '../../Chip/ChipWithTooltip';

const selectSx: SxProps = {
    '& .MuiInputBase-inputSizeSmall': {
        py: '6px',
        pl: '12px',
    },
};

const templateLabelSx: SxProps = {
    ...labelFontSemiBold,
    fontSize: '16px',
    fontWeight: 500,
    whiteSpace: 'normal',
    pr: '12px',
    py: 0,
};

const getTemplateChipSx = (visibility: SelectTemplateTypeEnum): SxProps => ({
    background:
        visibility === SelectTemplateTypeEnum.Private ? vars.brandDarkBlue : vars.trafficLightGreen,
    color: 'white',
    ...headingFontBold,
    fontSize: '14px',
    fontStyle: 'normal',
    fontWeight: 700,
    lineHeight: '120%',
});

const getChipLabel = (visibility: SelectTemplateTypeEnum): string =>
    visibility === SelectTemplateTypeEnum.Private ? 'private' : 'public';

export default ({ selectedTemplate, templates, handleChangeTemplate }: ISelectTemplateProps) => {
    const { t } = useTranslation('translations', { keyPrefix: 'shareEmailDialog' });

    return (
        <Select
            value={selectedTemplate.docUNID}
            onChange={(e: SelectChangeEvent<string>) => {
                handleChangeTemplate(templates.find(x => x.docUNID === e.target.value));
            }}
            inputProps={{ 'aria-label': 'Without label' }}
            size='small'
            sx={selectSx}
            renderValue={() => (
                <Typography sx={templateLabelSx}>
                    {selectedTemplate.docUNID !== 'default'
                        ? selectedTemplate.subject
                        : t('newEmailTemplateSubject')}
                </Typography>
            )}
        >
            {templates?.map(option => (
                <MenuItem
                    key={option.docUNID}
                    value={option.docUNID}
                    style={{
                        whiteSpace: 'normal',
                        maxWidth: '512px',
                        justifyContent: 'space-between',
                    }}
                >
                    <Typography sx={templateLabelSx}>
                        {option.docUNID !== 'default'
                            ? option.subject
                            : t('newEmailTemplateSubject')}
                    </Typography>

                    {option.docUNID !== 'default' && (
                        <ChipWithTooltip
                            label={t(getChipLabel(option.visibility))}
                            chipSx={getTemplateChipSx(option.visibility)}
                        />
                    )}
                </MenuItem>
            ))}
        </Select>
    );
};

interface ISelectTemplateProps {
    selectedTemplate: ISelectTemplate;
    templates: ISelectTemplate[];
    handleChangeTemplate: (template: ISelectTemplate) => void;
}

export interface ISelectTemplate {
    docUNID: string;
    subject: string;
    visibility: SelectTemplateTypeEnum;
}

export enum SelectTemplateTypeEnum {
    Private = '1',
    Public = '2',
}
